// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:10:32

export default {
  "id": "love-tile-trio",
  "slug": "love-tile-trio",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e8ce810f07284b498cc6fdccf817605e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e8ce810f07284b498cc6fdccf817605e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Love Tile Trio",
      "description": "Welcome to the Valentine's Day tile matching game! Your mission is to match and clear tiles from the board. Tap a tile and move it to an empty space or a spot with a matching tile. If no matches are available or there's no room, you'll need to try again. With a countdown timer and tricky puzzles, can you beat the Love Tile challenge?",
      "instructions": "Use a mouse or touchpad to play this lovely game.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "hexagon",
        "match3",
        "matching",
        "sorting",
        "stack"
      ]
    },
    "zh-CN": {
      "title": "爱心拼图三重奏",
      "description": "欢迎来到情人节拼图匹配游戏！你的任务是匹配并清除板上的拼图。点击一个拼图并将其移动到空白空间或匹配拼图的位置。如果没有匹配或没有空间，你需要再次尝试。带有倒计时计时器和难题，你能战胜爱情拼图挑战吗？",
      "instructions": "使用鼠标或触摸板来玩这款可爱的游戏。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "六边形",
        "三消",
        "匹配",
        "排序",
        "堆叠"
      ]
    },
    "zh-TW": {
      "title": "愛心拼圖三重奏",
      "description": "歡迎來到情人節拼圖匹配遊戲！你的任务是匹配並清除板上的拼圖。點擊拼圖並將其移動到空白空間或與之匹配的拼圖位置。如果沒有匹配或沒有空間，你將需要再次嘗試。在計時器與棘手的謎題下，你能否挑戰愛情拼圖？",
      "instructions": "使用滑鼠或觸控板來玩這款可愛的遊戲。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "六邊形",
        "配對3",
        "配對",
        "排序",
        "堆疊"
      ]
    },
    "zh-HK": {
      "title": "愛心拼圖三連組",
      "description": "歡迎來到情人節拼圖匹配遊戲！你的任務是匹配並清除板上的圖片。點擊圖片並將其移動到空白位置或與之匹配的位置。如果沒有匹配的圖片或沒有空間，你需要再次嘗試。有倒計時器和複雜的謎題，你能夠挑戰愛情拼圖挑戰嗎？",
      "instructions": "使用滑鼠或觸控板來玩這款可愛的遊戲。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "六邊形",
        "三消配對",
        "配對",
        "排序",
        "堆疊"
      ]
    },
    "ja": {
      "title": "ラブ・タイル・トリオ",
      "description": "バレンタインデー版のタイルマッチングゲームへようこそ！あなたのミッションは、ボードからタイルをマッチングしてクリアすることです。タイルをタップして、空きスペースまたは同じタイルがある場所に移動させます。マッチングが見つからない場合や空きスペースがない場合、もう一度試行します。カウントダウンタイマーと難しいパズルが待っています。ラブタイルの挑戦に勝てますか？",
      "instructions": "マウスやタッチパッドを使用して、この素敵なゲームを遊んでください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "六角形",
        "マッチ3",
        "一致",
        "並べ替え",
        "積み重ね"
      ]
    },
    "ko": {
      "title": "러브 타일 트리오",
      "description": "밸런타인데이 타일 매칭 게임을 환영합니다! 여러분의 임무는 보드에서 타일을 매칭하고 지우는 것입니다. 타일을 탭하고 빈 공간이나 같은 타일이 있는 공간으로 이동시켜주세요. 매칭이 없거나 공간이 없다면 다시 시도해야 합니다. 카운트다운 타이머와 어려운 퍼즐을 통해 사랑 타일 도전을 이기실 수 있을까요?",
      "instructions": "이 아름다운 게임을 플레이하려면 마우스나 터치패드를 사용하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "오각형",
        "매치3",
        "매칭",
        "정렬",
        "스택"
      ]
    },
    "fr": {
      "title": "Triplet de Carreaux d'Amour",
      "description": "Bienvenue dans le jeu de correspondance de la Saint-Valentin ! Votre mission consiste à correspondre et à nettoyer les tuiles du plateau. Tappez sur une tuile et déplacez-la vers un espace vide ou un emplacement avec une tuile correspondante. Si aucune correspondance n'est disponible ou s'il n'y a plus de place, vous devrez essayer à nouveau. Avec un chronomètre et des puzzles délicats, pouvez-vous battre le défi des Tuiles d'Amour ?",
      "instructions": "Utilisez une souris ou un pavé tactile pour jouer à ce joli jeu.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "hexagone",
        "match3",
        "correspondance",
        "tri",
        "empilement"
      ]
    }
  }
};
